import React from 'react';
import * as S from './style';
import { useHistory } from 'react-router-dom';
interface Props {
    tabs: Array<{
        path: string;
        name: string;
        active: boolean;
    }>;
}

function TabNavigation({ tabs }: Props): React.ReactElement {
    const history = useHistory();
    return (
        <S.TabNavigation>
            <S.TabContainer>
                {tabs.map((item, index) => (
                    <S.TapWarpper key={index} active={item.active}>
                        <S.TabLabel
                            onClick={(event: React.MouseEvent<HTMLLabelElement, MouseEvent>) => {
                                history.replace(item.path);
                            }}
                        >
                            {item.name}
                        </S.TabLabel>
                    </S.TapWarpper>
                ))}
            </S.TabContainer>
            <S.BorderLine height={1} backgroundColor={'gray_opacity_200'} />
        </S.TabNavigation>
    );
}

export default TabNavigation;
